import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet-async';

function IPConnectors() {
    const [active, setActive] = useState("Safe Area");
    const navigate = useNavigate();
    return (
        <>
        <Helmet>
    <title>
        IP68 Connectors & Terminal Blocks UAE | Waterproof Cable Connectors | Al Ibtekar
    </title>

    <meta
        name="description"
        content="Al Ibtekar supplies IP68 waterproof connectors, re-enterable gel connectors and terminal blocks for low voltage cable applications in the UAE, suitable for armoured and un-armoured cables, underground and fully submersible installations."
    />

    <meta
        name="keywords"
        content="IP68 connectors UAE, IP68 waterproof connectors UAE, IP68 cable connectors UAE, re-enterable gel connectors UAE, waterproof cable connectors UAE, gel filled cable connectors UAE, terminal blocks UAE, underground cable connectors UAE, armoured cable connectors UAE, low voltage cable connectors UAE"
    />

    <link
        rel="canonical"
        href="https://saig.me/ipconnectors"
    />

    <meta
        property="og:title"
        content="IP68 Connectors & Terminal Blocks UAE | Al Ibtekar"
    />

    <meta
        property="og:description"
        content="Waterproof IP68 connectors, re-enterable gel connectors and terminal blocks for reliable low voltage cable connections in demanding environments."
    />

    <meta
        property="og:url"
        content="https://saig.me/ipconnectors"
    />

    <meta
        property="og:type"
        content="website"
    />
</Helmet>
            <div className='newbanner-about newbanner-about3'>
                <div className="max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px]">
                    <h6 className="font-[500] font-kanit lg:text-[60px] text-[30px] lg:leading-[90px] leading-[40px] text-[#FFFFFF] lg:pb-[14px] pb-[4px]">IP68 Connectors & Terminal Blocks</h6>
                    <p className="lg:max-w-[582px] max-w-[250px] w-full font-[300] font-inter lg:text-[20px] text-[12px] lg:leading-[30px] leading-[16px] text-[#FFFFFF]">Waterproof and secure connectivity for extreme conditions.
                    </p>
                </div>
            </div>
            {/* <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.8 }}
                className="mt-[91px] overflow-hidden relative"
            >
                <motion.img
                    initial={{ scale: 1.2 }}
                    animate={{ scale: 1 }}
                    transition={{ duration: 1.2, ease: 'easeOut' }}
                    src="/assets/service/bg3.png"
                    className="w-full lg:h-auto h-[300px] object-cover"
                    alt="	Trusted cable management and termination solutions provider in the UAE"
                />
                <div className="absolute lg:top-[125px] top-[20px] max-w-[1440px] mx-auto w-full lg:px-[50px] px-[20px] left-1/2 -translate-x-1/2">
                    <motion.h6
                        initial={{ opacity: 0, y: 40 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.3, duration: 0.7 }}
                        className="font-[500] font-kanit lg:text-[70px] text-[30px] lg:leading-[90px] leading-[40px] text-[#FFFFFF] lg:pb-[14px] pb-[4px]"
                    >
                        IP68 Connectors & Terminal Blocks
                    </motion.h6>
                    <motion.p
                        initial={{ opacity: 0, x: -30 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ delay: 0.5, duration: 0.7 }}
                        className="max-w-[582px] w-full font-[300] font-inter text-[20px] leading-[30px] text-[#FFFFFF]"
                    >
                        Waterproof and secure connectivity for extreme conditions.
                    </motion.p>
                </div>
                <motion.h1
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.6, duration: 0.8 }}
                    className="absolute font-[600] font-kanit lg:text-[180px] text-[60px] lg:leading-[180px] leading-[70px] text-[#FFFFFF4F] right-[0px] lg:bottom-[86px] bottom-[40px]"
                >
                    IP68 Connectors
                </motion.h1>
            </motion.div> */}



             <div className='newbg'>

               <div className='max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px] overflow-hidden allheader mb-[20px]'>
<h2>IP68 Re-enterable Gel & Connectors</h2>
  <div className='line'></div>

<h3 className='text-left'>
Re-enterable gel is a two-component non-toxic insulating and sealing gel. It's suitable for low voltage applications and when cast in suitable junction box it ensures an IP68 degree of protection. Once poured, the insulation, characterised by very low viscosity, surrounds and envelopes any type of material.</h3>

               </div>
               </div>

            <div className='detail-div max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px] pb-[0px]'>

                <div className='detail-div-left'>
              
                    <div className='main-img'>

                        {/* <img src='/assets/saigip1.png' /> */}
                        <img src='/assets/saigip2.png' /> 
                    </div>


                </div>





                <div className='detail-div-right'>
                     <ul className="mt-4 grid grid-cols-1 ">
               {[
                 " Suitable for high temperature applications +200°C",
                 "Mixing Ratio 1:1 & Cross linking in only 10 minutes at 23°C!!",
                 "Soft-elastic, vibration absorbing, removable by hand",
                 "Non-toxic, safe, with no shelf life!!",
                 "Available in resin, rubber and putty formulations",
                
               ].map((item, i) => (
                  <li
      key={i}
      className="flex items-start gap-3 rounded-lg  bg-white px-4 py-1  transition"
    >
      <span className="mt-1 text-[#e09e0f] text-sm font-semibold">●</span>
      <span className="text-gray-700 text-[18px] leading-relaxed text-left aplus">
        {item}
      </span>
    </li>
               ))}
             </ul>
                </div>
            </div>



              <div className='newbg'>

               <div className='max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px] overflow-hidden allheader mb-[20px]'>


<h3 className='text-left'>IP68 Water Proof connectors - with and without gel filling for low voltage applications. Suitable for both armoured and un-armoured cables, whith availability in various configurations to suit most needs.
</h3>
               </div>
               </div>
  <div className='detail-div max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px] pb-[0px]'>

                <div className='detail-div-left'>
              
                    <div className='main-img'>

                        {/* <img src='/assets/saigip2.png' /> */}
                        <img src='/assets/saigip3.png'  className='ln-img2'/>
                    </div>


                </div>

                <div className='detail-div-right'>
                     <ul className="mt-4 grid grid-cols-1 gap-1">
               {[
                   "IP68 connectors - without gel",
                 "Suitable for un-armoured cables up to 14mm Dia.",
                 "Configurations: In-line, Tee, Y & Cross type",
                 "2, 3, 4 and 5 poles configurations",
                 "Pluggable versions - for panel mount",
                
               ].map((item, i) => (
                  <li
      key={i}
      className="flex items-start gap-3 rounded-lg  bg-white px-4   transition"
    >
      <span className="mt-1 text-[#e09e0f] text-sm font-semibold">●</span>
      <span className="text-gray-700 text-[18px] leading-relaxed text-left aplus">
        {item}
      </span>
    </li>
               ))}
             </ul>
                </div>
            </div>
<br/>
<br/>

              <div className='detail-div max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px] pb-[0px]'>

                <div className='detail-div-left'>
              
                    <div className='main-img'>

                      <img src='/assets/apip1.png'  className='ln-img2'/>
                    </div>


                </div>

       



     <div className='detail-div-right'>
                     <ul className="mt-4 grid grid-cols-1 gap-1">
               {[
                 " IP68 connectors - Gel filled ",
                 "Suitable for un-armoured & armoured cables",
                 "Configurations: 2-Way to 6-Way & Box Type",
                 "Suitability fully submersible or underground applications",
                 "Suitable for cable cross-section up to 6mm2   ",
                
               ].map((item, i) => (
                  <li
      key={i}
      className="flex items-start gap-3 rounded-lg  bg-white px-4  transition"
    >
      <span className="mt-1 text-[#e09e0f] text-sm font-semibold">●</span>
      <span className="text-gray-700 text-[18px] leading-relaxed text-left aplus">
        {item}
      </span>
    </li>
               ))}
             </ul>
              <Link to="/product">
                            <button className="backbtn mt-6">
                              Back To Products
                            </button>
                          </Link>
                </div>
            </div>
<br/>

            {/* <section style={{ background: `radial-gradient(104.59% 215.16% at 95% 10%, rgba(228, 74, 26, 0.16) 0%, rgba(228, 74, 26, 0) 29%), radial-gradient(104.59% 215.16% at 5% 90%, rgba(255, 27, 153, 0.15) 0%, rgba(255, 27, 153, 0) 25%)` }} className='lg:px-[100px] px-[20px]'>
                  <h6 className="font-[500] font-kanit lg:text-[42px] text-[30px] lg:leading-[50px] leading-[38px] text-[#000000] lg:pb-[80px] pb-[40px]">Product Recommendation</h6>
                  <div className="grid lg:grid-cols-3 grid-cols-2 lg:gap-[36px] gap-[20px] lg:pb-[142px] pb-[80px]">
                      <div>
                          <div className='group bg-[#E9EDEE] relative rounded-[12px] h-[427px] w-full flex justify-center items-center' style={{ boxShadow: "0px 4px 74px 0px #00000014" }}>
                              <img src="/assets/product/img1.png" alt="	Trusted cable management and termination solutions provider in the UAE" />
                              <button onClick={() => navigate('/product-detail')} className='absolute bottom-[16px] left-[16px] bg-[#FAB200] rounded-[30px] py-[15px] px-[28px] font-[500] text-[18px] leading-[28px] font-kanit text-[#181515] opacity-0 group-hover:opacity-100 transition-opacity duration-300'>
                                  View Details
                              </button>
                          </div>
                          <h6 className="pt-[30px] pb-[5px] font-[500] font-kanit text-[20px] leading-[24px] uppercase text-[#000000]">
                              junction box & enclosures
                          </h6>
                          <p className="font-[300] font-inter text-[18px] leading-[27px] text-[#454545]">
                              Polymer & Sheet Metal
                          </p>
                      </div>
                      <div>
                          <div className='group bg-[#E9EDEE] relative rounded-[12px] h-[427px] w-full flex justify-center items-center' style={{ boxShadow: "0px 4px 74px 0px #00000014" }}>
                              <img src="/assets/product/img2.png" alt="	Trusted cable management and termination solutions provider in the UAE" />
                              <button onClick={() => navigate('/product-detail')} className='absolute bottom-[16px] left-[16px] bg-[#FAB200] rounded-[30px] py-[15px] px-[28px] font-[500] text-[18px] leading-[28px] font-kanit text-[#181515] opacity-0 group-hover:opacity-100 transition-opacity duration-300'>
                                  View Details
                              </button>
                          </div>
                          <h6 className="pt-[30px] pb-[5px] font-[500] font-kanit text-[20px] leading-[24px] uppercase text-[#000000]">
                              re-enterable gel 7 fillers
                          </h6>
                          <p className="font-[300] font-inter text-[18px] leading-[27px] text-[#454545]">
                              Re-usable & Cast
                          </p>
                      </div>
                      <div>
                          <div className='group bg-[#E9EDEE] relative rounded-[12px] h-[427px] w-full flex justify-center items-center' style={{ boxShadow: "0px 4px 74px 0px #00000014" }}>
                              <img src="/assets/product/img3.png" alt="	Trusted cable management and termination solutions provider in the UAE" />
                              <button onClick={() => navigate('/product-detail')} className='absolute bottom-[16px] left-[16px] bg-[#FAB200] rounded-[30px] py-[15px] px-[28px] font-[500] text-[18px] leading-[28px] font-kanit text-[#181515] opacity-0 group-hover:opacity-100 transition-opacity duration-300'>
                                  View Details
                              </button>
                          </div>
                          <h6 className="pt-[30px] pb-[5px] font-[500] font-kanit text-[20px] leading-[24px] uppercase text-[#000000]">
                              Cables
                          </h6>
                          <p className="font-[300] font-inter text-[18px] leading-[27px] text-[#454545]">
                              Power & Instrumentation
                          </p>
                      </div>
                  </div>
              </section> */}
        </>
    )
}

export default IPConnectors